// extracted by mini-css-extract-plugin
export default {"arrows":"RailArrows_arrows__9w3Jv"};